// extracted by mini-css-extract-plugin
export var author = "Testimonial-module--author--fe1d1";
export var company = "Testimonial-module--company--570ce";
export var content = "Testimonial-module--content--5f320";
export var contentInformation = "Testimonial-module--contentInformation--a77f2";
export var cta = "Testimonial-module--cta--b466c";
export var ctaWrapper = "Testimonial-module--ctaWrapper--dadba";
export var mediaAvatar = "Testimonial-module--mediaAvatar--1c4e6";
export var position = "Testimonial-module--position--339da";
export var testimonialCta = "Testimonial-module--testimonialCta--8b0e7";
export var testimonialSection = "Testimonial-module--testimonialSection--00083";
export var wrapper = "Testimonial-module--wrapper--9dd63";
export var wrapperIntroText = "Testimonial-module--wrapperIntroText--4680b";
export var wrapperSubject = "Testimonial-module--wrapperSubject--c4ee5";